import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { prepareClientFormApiUrl } from '../app.const';
import { IWebFormSubmissionCopy } from '../common/form.store';

/**
 * Download PDF for a submitted webform: posts the answers just submitted to the forms API, which
 * renders them against the form definition (QuestPDF) and returns the file. The form token goes
 * in the Authorization header via the token interceptor, as for the submit itself.
 */
@Injectable({ providedIn: 'root' })
export class WebformPdfService {

  constructor(private http: HttpClient) { }

  public download(copy: IWebFormSubmissionCopy): Observable<Blob> {
    return this.http.post(prepareClientFormApiUrl('DownloadPdf'), {
      clientInputContents: copy.clientInputContents,
      optionLabels: copy.optionLabels
    }, { responseType: 'blob' });
  }

  /** Saves the PDF with a readable name: "<Form title> - yyyy-mm-dd.pdf". */
  public save(blob: Blob, formTitle: string): void {
    const date = new Date();
    const stamp = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const title = (formTitle || 'Form').replace(/[\\/:*?"<>|]/g, '-').trim();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title} - ${stamp}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
